import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { setTicketBaseModal, setCreateTicketModal } from '../actions/modalActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import TicketBaseListItem from '../../components/TicketBaseListItem'
import $ from 'jquery'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'
import * as general from '../../constants/General'

function TicketBaseModal(propsModal) {
    const props = propsModal;
    const [data, setData] = useState({ inputField: '', tickets: [] });

    function cancelTap() {
        setData({ inputField: '', tickets: [] });
        props.setTicketBaseModal(false, 'default');
    }

    useEffect(() => {
        if (props.ticketBaseModal.show === true) {
            showKeyboard()
        }
    }, [props.ticketBaseModal.show]);

    function resetTap() {
        $('#search').val('');
        setData({ inputField: '', tickets: [] });
    }

    function processTouchTap(ticket) {
        const dispatch = props.ticketBaseModal.dispatch;
        fetch(`${general.API_URL_GET_TICKETUSAGES}${ticket.TicketId}`).then(result => result.json()).then(ticketusages =>
            dispatch(setCreateTicketModal(true, () => updateInputField(data.inputField), null, dispatch, ticket, ticketusages)));
    }

    function updateInputField(input) {
        if (data.tickets.length > 1) {
            fetch(`${general.API_URL_GET_TICKETS}${input}`).then(result => result.json()).then(tickets => {
                prepareData(input, tickets)
            }
            );
        }
        else {
            cancelTap()
        }
    }

    function prepareData(description, newTickets) {
        setData({ inputField: description, tickets: newTickets });
    }

    function updateInputFieldAfterSearch(input) {
        fetch(`${general.API_URL_GET_TICKETS}${input}`).then(result => result.json()).then(tickets => prepareDataAfterSearch(input, tickets));
    }

    function prepareDataAfterSearch(description, newTickets) {
        setData({ inputField: description, tickets: newTickets });
        let ticket = newTickets.find(tick => tick.Barcode === description);
        if (ticket !== null && ticket !== undefined) {
            processTouchTap(ticket);
        }
    }

    function showKeyboard() {
        props.toggleKeyboard(true, '#search', props.getTranslation(resource.SEARCH_TERM), updateInputFieldAfterSearch, null, false);
    }

    return (
        <Modal className='ticketBaseModal'
            contentLabel=""
            isOpen={props.ticketBaseModal.show}
            style={properties.ticketBaseModalStyle}
        >
            <div className="ticketBaseModal_header">
                <div className="header_top">
                    {props.getTranslation(resource.TICKET_LIST)}
                </div>
            </div>
            <div className="ticketBaseModal_content">
                <div>
                    <div className="search_bar_div">
                        <input
                            id="search"
                            className="search_bar"
                            placeholder={props.getTranslation(resource.SEARCH_TERM)}
                            onClick={showKeyboard}
                            readOnly="readOnly"
                            value={data.inputField} />
                        {data.inputField !== '' &&
                            <button className="btnReset" onClick={resetTap} >
                                {props.getTranslation(resource.RESET)}
                            </button>
                        }
                    </div>
                    <div className="ticketList" >
                        {
                            data.tickets.map(tick =>
                                <TicketBaseListItem
                                    key={tick.TicketId}
                                    Ticket={tick}
                                    Callback={processTouchTap}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
            <div className="ticketBaseModal_footer">
                <button className="btnCancel" style={{ width: "100%" }} onClick={cancelTap} >
                    {props.getTranslation(resource.CANCEL)}
                </button>
            </div>

        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        ticketBaseModal: state.modalState.ticketBaseModal,
        keyboard: state.layoutState.keyboard,
    }
}

export default connect(mapStateToProps, {
    setTicketBaseModal,
    toggleKeyboard,
    getTranslation,
    setCreateTicketModal
})(TicketBaseModal)



// WEBPACK FOOTER //
// src/modal/components/TicketBaseModal.jsx